import React from 'react';
import Subsection from '../Subsection/Subsection.js';
import './Section.less';

const Section = ({headline, description, image, subsections, cta, id}) => {
    const sectionCta = cta ? {__html: cta} : false;

    const fireEdapEvent = (ctaObj) => {
        if (typeof window !== 'undefined') {
            window.edap.push((edap) => {
                edap.trigger('generic.event', {
                    eventcategory: 'travel-with-confidence',
                    eventaction: 'link.click',
                    eventlabel: ctaObj.edapLabel,
                });
            });
        }
    };

    const handleClick = (e) => {
        if (cta) {
            fireEdapEvent(cta);
        }
    };

    return (
        <section className={`Section Section--${id} content-padding`} id={id}>
            <div className="Section__inner content-container">
                <div className="Section__header">
                    <h1>{headline}</h1>
                    <p>{description}</p>
                    {sectionCta && (
                        <a href={cta.url} onClick={handleClick}>
                            {`${cta.label}`}
                        </a>
                    )}
                </div>
                {image && (
                    <div className="Section__image">
                        <img
                            src={require(`../../assets/${image}.png`)}
                            alt=""
                            className="img-responsive"
                        />
                    </div>
                )}
                <div className="Section__content">
                    {subsections.map((subsection, j) => {
                        if (subsection.headline.length > 0) {
                            return (
                                <Subsection
                                    {...subsection}
                                    edapHandler={fireEdapEvent}
                                    key={j}
                                />
                            );
                        }
                        return null;
                    })}
                </div>
            </div>
        </section>
    );
};

export default Section;
